<template>
  <div id="detailsInfo" ref="pageContainer">
    <header-top
      showBack
      class="basic-header"
    ></header-top>
    <header-top
      showBack
      v-if="isActive"
      class="basic-header header-visible"
    ></header-top>
    <div
      id="toolbarContainer"
      :class="{ 'active-toolbar': isActive }"
    />
    
    <el-form
      ref="information"
      :model="information"
      :rules="informationRules"
      label-width="5rem"
      class="content"
      label-position="top"
    >
      <el-input
        v-model="information.name"
        class="info-title"
        placeholder="请在这里输入标题"
      ></el-input>
      <el-input
        v-model="information.source"
        class="info-source"
        placeholder="请输入来源"
      ></el-input>
      <div class="editor-container">
        <!-- 工具栏容器 -->
        <!-- <div id="toolbarContainer" class="active" v-if="isActive" :style="{ width: toolbarWidth + 'px' }" /> -->
        <!-- 编辑器容器 -->
        <div id="editor" v-if="information.content">
          <p>再次输入正文</p>
        </div>
        <div id="editor" v-html="information.content" v-else></div>
      </div>
      <el-form-item label="资讯封面" class="auto-height">
        <div class="covers">
          <div
            class="cover-img"
            v-for="(url, index) in information.imageUrls"
            :key="index"
            v-show="information.imageUrls.length > 0 && index < 3"
          >
            <img
              :src="url"
              alt="headImg"
              class="basic-head-img"
              :key="index"
              v-if="index < 3"
            />
            <div class="delete" @click="getUrl(url)">删除</div>
          </div>
          <div class="default-box" v-if="information.imageUrls.length < 3">
            <i class="el-icon-plus"></i>
            选择封面
            <div class="add-type">
              <el-upload
                class="upload-demo"
                action="https://jsonplaceholder.typicode.com/posts/"
                :show-file-list="false"
                :http-request="getFile"
              >
                <span>本地上传</span>
              </el-upload>

              <span @click="showPhoto">从正文选择</span>
            </div>
          </div>
        </div>
        <div class="form-tip">
          只支持.jpg，.png，.jpeg格式，资讯封面最多只能上传3张，大小不超过5M
        </div>
      </el-form-item>
      <el-form-item label="类型" prop="type" class="auto-height">
        <div class="item">
          <div class="input-form">
            <el-select
              v-model="information.type"
              placeholder="请选择资讯类型"
              class="handle-select"
            >
              <el-option
                v-for="item in typeDic"
                v-show="item.isDefault"
                :key="item.option"
                :label="item.option"
                :value="item.option"
              ></el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="关键词" prop="keyWord" class="auto-height">
        <div class="item">
          <div class="input-form">
            <el-input
              v-model="information.keyWord"
              class="input"
              placeholder="请输入关键词"
              maxlength="30"
              clearable
            ></el-input>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="优先级" prop="sort" class="auto-height">
        <div class="item">
          <div class="input-form">
            <el-select
              v-model="information.sort"
              placeholder="请选择优先级"
              class="handle-select"
            >
              <el-option
                v-for="item in 10"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <div class="tips">请选择优先级，数值越小，优先级更高；</div>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="发布时间" prop="startTime" class="auto-height">
        <div class="item">
          <div class="input-form">
            <el-date-picker
              v-model="information.startTime"
              type="datetime"
              placeholder="选择日期"
            >
            </el-date-picker>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="摘要" prop="summary" class="auto-height">
        <div class="item-summary">
          <div class="input-form">
            <el-input
              v-model="information.summary"
              class="input"
              placeholder="请输入资讯摘要"
              type="textarea"
              maxlength="200"
              show-word-limit
              resize="none"
              clearable
            ></el-input>
          </div>
        </div>
      </el-form-item>
      <el-form-item class="auto-height">
        <el-row class="footer">
          <el-col>
            <div class="btn-box">
              <el-button
                :loading="confirmLoading == 'information'"
                type="primary"
                @click="confirm('information','information')"
                >保存</el-button
              >
              <el-button
                :loading="confirmLoading == '预览'"
                type="primary"
                @click="confirm('information', '预览')"
                >保存并预览</el-button
              >
              <el-button
                :loading="confirmLoading == '发布'"
                type="primary"
                @click="confirm('information', '发布')"
                >保存并发布</el-button
              >
              <!-- <el-button @click="cancel">取 消</el-button> -->
            </div>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <el-dialog
      title="选择封面"
      :visible.sync="isImgShow"
      width="600px"
      custom-class="employe-dialog photo-dialog"
      @close="handleClose"
    >
      <div class="img" v-for="(url, index) in photoUrl" :key="index">
        <el-image
          :src="url"
          @click="getUrl(url)"
          :class="{ active: information.imageUrls.indexOf(url) != -1 }"
        >
          <div slot="placeholder" class="image-slot">
            加载中<span class="dot">...</span>
          </div>
        </el-image>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click.stop="handleClose">取消</el-button>
        <el-button type="primary" @click.stop="handleClose">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import headerTop from "@/components/HeaderTop";
import {
  getInformation,
  uploadInformationfile,
  updateInformation,
  updateStatus
} from "@/http/api/information";
import { dateFormat } from '@/common/filters';
import { getInformationSettings } from "@/http/api/system";
import CKEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import "@ckeditor/ckeditor5-build-decoupled-document/build/translations/zh-cn";
export default {
  // props: ['information'],
  components: {
    headerTop,
  },
  data() {
    this.scrollDom = null;
    return {
      id: this.$route.params.id,
      typeDic: {},
      photoUrl: [],
      toolbarWidth: "",
      headerText: "基本信息",
      isActive: false,
      isImgShow: false,
      information: {
        name: "",
        type: "",
        sort: 0,
        source: "",
        keyWord: "",
        summary: "",
        content: "",
        startTime: "",
        more: "",
        imageUrls: [],
      },
      imageUrl: "",
      confirmLoading: false,
      editor: null,
      scrollTop: 0,
      informationRules: {
        startTime: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        name: [{ required: true, message: "请输入资讯名称", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.toolbarWidth = this.$refs.pageContainer.offsetWidth - 1;
    this.getInformation();
    this.getInformationSetting();
    this.$nextTick(() => {
      this.initEvent();
    });
  },
  destroyed() {
    document
      .querySelector(".main-container")
      .removeEventListener("scroll", this.scrollHander);
  },
  methods: {
    initEvent() {
      document
        .querySelector(".main-container")
        .addEventListener("scroll", this.scrollHander, true);
    },
    scrollHander() {
      const top = document.querySelector(".main-container").scrollTop;
      if (top > 0) {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    },
    getFile(item) {
      const data = new FormData();
      data.append("file", item.file);
      uploadInformationfile(data).then((res) => {
        //console.log(res, 998877);
        this.information.imageUrls.push(res.result.url);
      });
    },
    getUrl(url) {
      if (this.information.imageUrls.indexOf(url) == -1) {
        if (this.information.imageUrls.length < 3) {
          this.information.imageUrls.push(url);
        } else {
          this.$message({
            message: "最多只可选三张封面",
            showClose: true,
          });
        }
      } else {
        let index = this.information.imageUrls.indexOf(url);
        this.information.imageUrls.splice(index, 1);
      }
    },
    handleClose() {
      this.isImgShow = false;
    },
    showPhoto() {
      var data = [];
      this.editor
        .getData()
        .replace(
          /<img [^>]*src=['"]([^'"]+)[^>]*>/g,
          function (match, capture) {
            data.push(capture);
          }
        );
      //console.log(this.editor.getData(), "获取的正文图片");
      this.photoUrl = data;
      if (this.photoUrl.length > 0) {
        this.isImgShow = !this.isImgShow;
      } else {
        this.$message({
          message: "正文中暂无图片",
          showClose: true,
        });
      }
    },
    getInformationSetting() {
      getInformationSettings().then((res) => {
        res.result.map((item) => {
          if (item.name == "Deer.Information.Collection.InformationType") {
            this.typeDic = item.value;
          }
        });
      });
    },
    
    confirm(formName, val) {
      this.confirmLoading = val;
      this.information.content = this.editor.getData();
      this.information.startTime = dateFormat(this.information.startTime)
      console.log(this.information,"获取的information");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updateInformation(this.id, this.information)
            .then((res) => {
              if (res && res.result) {
                this.confirmLoading = false;
                
                if (val == "预览") {
                  this.$message.success({
                    message: res.message,
                    showClose: true,
                  });
                  this.$router.push({
                    path: `/information/information-preview/${this.id}`,
                  });
                } else if (val == "发布") {
                  updateStatus(this.id, "Published").then(res => {
                    if (res && res.code==10200) {
                      console.log(888);
                      this.$message.success({
                        message: res.message,
                        showClose: true,
                      });
                      this.$router.push({
                        path: `/information/information`,
                      });
                    }
                  });
                }
              }
            })
            .catch((err) => {
              this.confirmLoading = false;
            });
        } else {
          return false;
        }
      });
    },
    getInformation() {
      getInformation(this.id).then((res) => {
        if (res && res.result) {
          this.information.name = res.result.name;
          this.information.type = res.result.type;
          this.information.sort = res.result.sort;
          this.information.source = res.result.source;
          this.information.keyWord = res.result.keyWord;
          this.information.summary = res.result.summary;
          this.information.content = res.result.content;
          this.information.startTime = res.result.startTime;
          this.information.more = res.result.more;
          this.information.imageUrls = res.result.imageUrls;
          this.initCKEditor();
        }
      });
    },
    initCKEditor() {
      let that = this;
      class UploadAdapter {
        constructor(loader, editor, compent) {
          this.loader = loader;
          this.editor = editor;
          this.compent = compent;
        }
        upload() {
          return new Promise((resolve, reject) => {
            const size = this.loader.file.size;
            if (size / 1024 / 1024 > 20) {
              this.compent.$message({
                message: "图片不能大于20M",
              });
              return false;
            }

            const data = new FormData();
            this.loader.file.then((file) => data.append("file", file));
            uploadInformationfile(data).then((res) => {
              if (res) {
                if (res && res.result) {
                  resolve({
                    default: res.result.url,
                  });
                }
              } else {
                this.compent.$message({
                  message: "文件上传失败: " + this.loader.file.name,
                });
              }
            });
          });
        }

        abort() {}
      }
      // 初始化编辑器
      CKEditor.create(document.querySelector("#editor"), {
        // removePlugins: ["MediaEmbed"], // 除去视频按钮
        language: "zh-cn", // 中文
        ckfinder: {
          uploaded: 1,
          url: "/",
          uploadUrl: "[[@{/upload}]]",
          // 后端处理上传逻辑返回json数据,包括uploaded(选项true/false)和url两个字段
        },
        // mediaEmbed: {
        //   // 视频配置
        //   providers: [
        //     {
        //       name: "myprovider",
        //       url: [
        //         /^lizzy.*\.com.*\/media\/(\w+)/,
        //         /^www\.lizzy.*/,
        //         /(http|https):\/\/([\w.]+\/?)\S*/,
        //       ],
        //       html: (match) => {
        //         //获取媒体url
        //         const input = match["input"];
        //         return (
        //           '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 70%;">' +
        //           `<iframe src="${input}" ` +
        //           'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' +
        //           'frameborder="0" allowtransparency="true" allow="encrypted-media">' +
        //           "</iframe>" +
        //           "</div>"
        //         );
        //       },
        //     },
        //   ],
        // },

        autosave: {
          save(editor) {
            return this.confirm("information");
          },
          waitingTime: 60000,
        },
      })
        .then((editor) => {
          const toolbarContainer = document.querySelector("#toolbarContainer");
          toolbarContainer.appendChild(editor.ui.view.toolbar.element);
          // 加载了适配器
          editor.plugins.get("FileRepository").createUploadAdapter = (
            loader
          ) => {
            return new UploadAdapter(loader, editor, this);
          };
          this.editor = editor; // 将编辑器保存起来，用来随时获取编辑器中的内容等，执行一些操作
          this.editor.setData(
            that.information.content
              ? that.information.content
              : "从这里开始写正文"
          );
        })

        .catch((error) => {});
    },
  },
  // cancel() {},
};
</script>
<style lang="scss" scoped>
@import "@/styles/mixin.scss";
#detailsInfo {
  // height: 100vh;
  // padding: 25px 20px;
  // box-shadow: 0 0 13px 3px rgba(0, 0, 0, 0.1);
  // background: #fff;
  .header-visible {
    position: fixed;
    top: 48px;
    z-index: 100;
    background:#fff;
    box-shadow:0 0 0 0 rgba(0,0,0,0);
  }
  .title {
    @include flex(row, center);
    justify-content: space-between;
    margin-bottom: 18px;
    font-size: 14px;
    color: #000;
    font-weight: bold;
  }
  ::v-deep .el-form {
    .el-form-item__label {
      margin-bottom: 5px;
      font-size: 14px;
      color: #333;
    }
  }
  ::v-deep #toolbarContainer {
    // position: fixed;
    // top: 110px;
    // right: 15px;
    // z-index: 500;
    width: 100%;
    height: 38px;
    background: #fff;
    border-bottom: 1px solid #dfdfdf;
    .ck-rounded-corners {
      border: 0;
    }
    .ck.ck-toolbar {
      border: 0;
    }
  }
  .active-toolbar {
    position: fixed;
    top: 90px;
    right: 0;
    z-index: 100;
    border-bottom: 1px solid #dfdfdf;
  }
  ::v-deep #editor {
    margin-bottom: 20px;
    padding: 20px 10px;
    min-height: 70vh;
    background: #fff;
    border-bottom: 1px solid #dfdfdf;
  }
  .ck-focused {
    border: 0;
    box-shadow: 0 0 0 #fff !important;
  }
  .footer {
    width: 100%;
    padding-bottom: 20px;
    text-align: left;
    background: #fff;
  }
  ::v-deep .content {
    margin: 30px auto 20px;
    padding: 30px 95px 0px 72px;
    width: 800px;
    background: #fff;
    .info-title {
      font-size: 24px;
      font-weight: bold;
      .el-input__inner {
        border: 0;
      }
    }
    .info-source {
      margin-top: 10px;
      font-size: 14px;
      .el-input__inner {
        border: 0;
      }
    }

    .info-title ::-webkit-input-placeholder {
      color: #d9d9d9;
      font-size: 24px;
    }
    .info-source ::-webkit-input-placeholder {
      font-size: 14px;
    }
    .item {
      width: 390px;
      .el-select {
        width: 100%;
      }
      .el-date-editor {
        width: 100%;
        .el-icon-date {
          left: 0;
        }
        .el-input__inner {
          padding-left: 30px;
        }
        .el-icon-circle-close {
          right: 0;
        }
      }
      .tips {
        font-size: 12px;
        color: #909090;
      }
    }
    .item-summary {
      width: 700px;
    }
    .covers {
      @include flex(row, flex-end);
      margin-bottom: 10px;
      .cover-img {
        @include flex(column, center);
        justify-content: center;
        position: relative;
        padding: 10px;
        width: 124px;
        height: 84px;
        text-align: center;
        .basic-head-img {
          max-width: 124px;
          max-height: 84px;
          width: auto;
          height: auto;
        }
        .delete {
          opacity: 0;
          transform: all 0.3s;
          position: absolute;
          bottom: 10px;
          left: 10px;
          width: 124px;
          height: 20px;
          line-height: 20px;
          cursor: pointer;

          font-size: 12px;
          color: #fff;
          background: rgba(0, 0, 0, 0.3);
        }
        &:hover {
          .delete {
            opacity: 1;
          }
        }
      }
      .default-box {
        @include flex(column, center);
        justify-content: center;
        position: relative;
        margin: 10px;
        border: 1px dashed #dfdfdf;
        width: 160px;
        height: 84px;
        color: $--color-primary;
        .el-icon-plus {
          font-size: 16px;
        }
        .add-type {
          position: absolute;
          bottom: 0;
          left: 0;
          opacity: 0;
          width: 100%;
          height: 30px;
          transition: all 0.2s;
          background: rgba(0, 0, 0, 0.3);
          color: #fff;

          span {
            display: inline-block;
            transition: all 0.2s;
            width: 50%;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: #000;
            cursor: pointer;
            opacity: 0.5;
            &:hover {
              opacity: 1;
            }
          }
          .upload-demo {
            display: inline-block;
            width: 50%;
            height: 30px;
            .el-upload {
              width: 100%;
              span {
                width: 100%;
              }
            }
          }
        }
        &:hover {
          .add-type {
            opacity: 1;
          }
        }
      }
      .upload-btn {
        margin-left: 10px;
        padding: 10px 0;
        height: 12px;
        line-height: 12px;

        cursor: pointer;
        color: $--color-primary;
      }
    }
  }
  // @media (max-width: 1367px) {
  //   .content {
  //     margin: 20px;
  //   }
  // }

  // @media (min-width: 1367px) and (max-width: 1920px) {
  //   .content {
  //     margin: 20px 100px;
  //   }
  // }

  // @media (min-width: 1920px) {
  //   .content {
  //     margin: 20px 180px;
  //   }
  // }
}
::v-deep .photo-dialog {
  .el-dialog__body {
    @include flex(row, center);
    flex-wrap: wrap;
    .el-image {
      @include flex(column, center);
      justify-content: center;
      margin: 0 10px 10px;
      padding: 5px;
      border: 1px solid #fff;
      width: 146px;
      height: 84px;
      text-align: center;
      cursor: pointer;
      img {
        max-width: 146px;
        max-height: 84px;
        width: auto;
        height: auto;
      }
    }
    .active {
      border: 1px solid #dfdfdf;
    }
  }
}
</style>

